import Service from "core/service";
import type { AxiosError } from 'axios';
export class ProfileService extends Service {
  async updateAvatar (formData: any): Promise<any> {
    try {
      return this.postFormData("/User/Avatar", formData);

    } catch (error) {
      throw (error as AxiosError).response;
    }
  }

  async selectWorkingHour (param: any) {
    try {
      let params: any = {
      };

      if(param){
        params["summary"] = param.sortBy; //Month or Year
      }
      const res = this.get("/Profile/WorkingHours", params);
      return res;

    } catch (error) {
      throw (error as AxiosError).response;
    }
  }

  async selectTopApprover (param: any) {
    try {
      let params: any = {
      };

      if(param){
        params["summary"] = param.sortBy; //Month or Year
      }
      const res = this.get("/Profile/TopApprovers", params);
      return res;

    } catch (error) {
      throw (error as AxiosError).response;
    }
  }

  patchForceLogout () {
    try {
      return this.patch("/Profile/ForceLogout");
    } catch (error) {
      throw (error as AxiosError).response;
    }
  }
}
